import FuturePetSpeciesData from '../data/FuturePetSpecies.json';
import {
  FutureSpeciesItem,
  FuturePetSpecies,
} from '../data/FuturePetSpecies.schema';

export type AllSpecies = FutureSpeciesItem['id'];

const AllSpeciesData = FuturePetSpeciesData as FuturePetSpecies;

export const species = AllSpeciesData.sort(
  (a, b) => a.encyclopedia_order - b.encyclopedia_order,
).map((x) => x.id);
